export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const resolveImageUrl = (url) => {
  if (!url) return '';
  return url.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
};

export const formatDate = (iso, lang = 'en') => {
  if (!iso) return '';
  const locale = lang === 'hi' ? 'hi-IN' : lang === 'ta' ? 'ta-IN' : 'en-IN';
  return new Date(iso).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
};
